// Shared by profile, loyalty and checkout forms, including CMS form instances.
const streetAddressFieldNames = [
  'address',
  'street',
  'house-number',
  'address__street',
  'address_address',
  'company_address',
  'diff_address',
  'billing_address_1',
  'shipping_address_1',
  'edit-address-form-ulica',
];

// eslint-disable-next-line no-unused-vars
const getAddressFieldValidators = (form) => {
  const fields = {};
  form.querySelectorAll('input, textarea').forEach((element) => {
    if (
      !element.name ||
      (!streetAddressFieldNames.includes(element.name) &&
        !element.matches('[data-address-field], [autocomplete="street-address"], [autocomplete="address-line1"]'))
    ) {
      return;
    }
    fields[element.name] = {
      validators: {
        callback: {
          message: localData.translations?.address_warning || 'Prosim vpišite hišno številko',
          callback: (input) => {
            if (input.element.getAttribute('data-places-missing-street-number') === 'true') return false;
            if (!input.value.trim() && !input.element.required) return true;
            return /\d/.test(input.value);
          },
        },
      },
    };
  });
  return fields;
};
